/**
 * Check if a camp has Family Camps as zusatzcategory
 * This function works with both populated camp data and ID strings
 * @param camp - The camp object with zusatzcategory
 * @returns boolean indicating if this is a family camp
 */
export function isFamilyCamp(camp: any): boolean {
  if (!camp?.zusatzcategory) {
    return false
  }

  // Family Camps category ID
  const FAMILY_CAMPS_CATEGORY_ID = '68e4d38bf98dce7e91cc6ac1'

  // If zusatzcategory is a string (ID), compare directly
  if (typeof camp.zusatzcategory === 'string') {
    return camp.zusatzcategory === FAMILY_CAMPS_CATEGORY_ID
  }

  // If zusatzcategory is an object (populated), check the ID
  if (typeof camp.zusatzcategory === 'object' && camp.zusatzcategory.id) {
    return camp.zusatzcategory.id === FAMILY_CAMPS_CATEGORY_ID
  }

  return false
}
